module.exports = __webpack_public_path__ + "fonts/94927322b0cadb5e982a4b4dced9e048.eot";